import { render, staticRenderFns } from "./AccordionList.vue?vue&type=template&id=0bfb7988&scoped=true"
import script from "./AccordionList.vue?vue&type=script&lang=js"
export * from "./AccordionList.vue?vue&type=script&lang=js"
import style0 from "./AccordionList.vue?vue&type=style&index=0&id=0bfb7988&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfb7988",
  null
  
)

export default component.exports